import { useEffect, useState } from 'react'
import { OrgCard } from '../../planning/OrgCard'
import { GetPlanOrganizationsForAnnualPlan, GetAnnualPlanTeam } from '../../../../services/AnnualPlanService'
import { type OrganizationOption } from '../../../../models/requestObjects/CommonObjects'
import { Box, CircularProgress } from '@mui/material'
import { useAnnualPlanUserRole } from '../../../../hooks/use-annualPlanUserRole'
import { AnnualPlanRole } from '../../../../models/AnnualPlanRole'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { AppRoutes } from '../../../Routes'
import { ImplementationDetailsTabs } from '../ImplementationDetails'

export const ProgressReportsOverview = (): JSX.Element => {
  const [isds, setIsds] = useState<OrganizationOption[]>([])
  const [loading, setLoading] = useState(true)

  const { rcnId, planId } = useParams()
  const annualPlanId = planId != null ? Number(planId) : 0
  const { user, userRole, isLoading: roleLoading } = useAnnualPlanUserRole(planId != null ? Number(planId) : 0)
  const nav = useNavigate()

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      if (roleLoading || userRole == null) return

      const isPlanContributor = userRole === AnnualPlanRole.PlanContributor

      if (isPlanContributor) {
        GetAnnualPlanTeam(annualPlanId)
          .then(planTeam => {
            const matchedTeamMember = planTeam.find(member => member.userId === user?.id)
            if (matchedTeamMember != null) {
              navigateToOrganizationReports(matchedTeamMember?.organizationId)
            } else {
              console.error('No matching team member found for the current user.')
            }
          }).catch(error => {
            console.error('Error fetching plan team:', error)
          }).finally(() => { setLoading(false) })
      } else {
        GetPlanOrganizationsForAnnualPlan(annualPlanId)
          .then(({ response }) => { setIsds(response) })
          .catch((error) => { console.error('Error fetching ISDs:', error) })
          .finally(() => { setLoading(false) })
      }
    }

    void loadData()
  }, [annualPlanId, user?.id, userRole, roleLoading])

  const navigateToOrganizationReports = (organizationId: number): void => {
    if (rcnId == null || planId == null) return

    const path = generatePath(AppRoutes.IMPLEMENTATION_PROGRESS_REPORTS_ORGANIZATION, {
      rcnId,
      planId,
      tab: String(ImplementationDetailsTabs.ProgressReports),
      orgId: organizationId.toString()
    })
    nav(path)
  }

  if (loading || roleLoading) return <CircularProgress />

  return (
    <Box data-testid="isd-midyear" sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '44px'
    }}
    >
      {isds.map((isd) => (
        <OrgCard key={isd.name} name={isd.name} buttonText="View Reports" onClick={() => { navigateToOrganizationReports(isd.id) }} />
      ))}
    </Box>
  )
}
